module.exports = ".container {\n  margin-bottom: 2em;\n  text-align: center;\n  cursor: pointer; }\n\n.container .icon {\n  height: 30px;\n  width: 30px;\n  display: inline-block;\n  vertical-align: middle; }\n\n.container .content {\n  display: inline-block;\n  vertical-align: middle; }\n\n.button-custom-card {\n  height: 1.6em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/generic-form-buttons/generic-form-buttons.component.scss
// module id = ./src/app/widgets/generic-form-buttons/generic-form-buttons.component.scss
// module chunks = main